import { render, staticRenderFns } from "./RelatorioPix.vue?vue&type=template&id=64f80a1c"
import script from "./RelatorioPix.vue?vue&type=script&lang=ts"
export * from "./RelatorioPix.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioPix.vue?vue&type=style&index=0&id=64f80a1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports